import { createFileRoute, Outlet } from "@tanstack/react-router"

import { SidebarInset, SidebarProvider } from '@/ui/sidebar'
import { AppSidebar } from '@components/app-sidebar.tsx'

export const Route = createFileRoute('/_app')({
    component: AppLayout,
})

function AppLayout() {
    return (
        <SidebarProvider className="h-screen overflow-hidden">
            <AppSidebar/>
            <SidebarInset>
                <main className="flex-1 min-h-0 overflow-auto">
                    <Outlet/>
                </main>
            </SidebarInset>
        </SidebarProvider>
    )
}
